import PWAPage from './PWAPage';

export default PWAPage;
